import BaseError from "./BaseError";

export default class UnexpectedError<T> extends BaseError<T> {}
